import api from "../libs/api";

export default {
  postPayment: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post("/process-payment", data)
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch((error) => reject(error));
    });
  },
   getOrders: () => {
    return new Promise((resolve, reject) => {
      api()
        .get("/orders")
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch((error) => reject(error));
    });
  },
  getTransactionsWithOrders: () => {
    return new Promise((resolve, reject) => {
      api()
        .get("/transactions-with-orders")
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch((error) => reject(error));
    });
  },
  uploadOrderPhotos: (orderId, formData) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/orders/${orderId}/photos`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(new Error(`Failed with status: ${status}`));
        })
        .catch((error) => reject(error));
    });
  },
  deleteOrderPhoto: (orderId, filename) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/orders/${orderId}/photo`, { data: { filename } })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(new Error(`Failed with status: ${status}`));
        })
        .catch((error) => reject(error));
    });
  },
  softDeleteOrder: (orderId) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/orders/${orderId}/soft-delete`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(new Error(`Failed with status: ${status}`));
        })
        .catch((error) => reject(error));
    });
  },
  
};
